import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { headingStyles, paragraphRegular } from '@helpers/typography';
import styled, { css } from 'styled-components';
const Container = styled.section `
  ${baseGrid};
`;
const centralColumns = css `
  grid-column: 1 / -1;
  text-align: center;

  @media ${from(Device.Tablet)} {
    grid-column: 2 / -2;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 3 / -3;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 4 / -4;
  }
`;
const leftColumns = css `
  grid-column: 1 / -1;

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 6;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 5;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 1 / span 4;
  }
`;
const Title = styled.h2 `
  ${headingStyles};

  font-size: ${fluid(28, 38)};
  margin: 0;

  ${Container}[data-alignment='centre'] & {
    ${centralColumns};
  }

  ${Container}[data-alignment='left'] & {
    ${leftColumns};
  }
`;
const Introduction = styled.p `
  ${paragraphRegular};

  margin: ${fluid(16, 24)} 0 0;

  ${Container}[data-alignment='centre'] & {
    ${centralColumns};
  }

  ${Container}[data-alignment='left'] & {
    ${leftColumns};
  }
`;
const TitleAndIntroductionStyles = {
    Container,
    Title,
    Introduction,
};
export default TitleAndIntroductionStyles;
